export default __webpack_public_path__ + "static/media/aupfln.cfb53fae.png";